const processSearchResultData = (data) => {
    const { statusCode, message, data: searchResult } = data;
    const { result } = searchResult;
    if (result.length <= 20) return { statusCode, message, data: result };
    const firstTwenty = result.slice(0, 20);
    return { statusCode, message, data: { result: firstTwenty } };
};

export default processSearchResultData;
